import classnames from 'classnames';

const OverlaySubtitle = ({ overlay }) => {
    const { contentParams } = overlay;

    const classes = classnames('overlay-subtitle', contentParams.theme);

    if (!contentParams.subtitle || !contentParams.subtitle.length) {
        return null;
    }

    return (
        <div className={classes}>
            {contentParams.subtitle.map((rule) => {
                return (
                    <span className="overlay-subtitle__rule" key={rule}>
                        {rule}
                    </span>
                )
            })}
        </div>
    )
}

export default OverlaySubtitle
